module.exports = __webpack_public_path__ + "media/images/icon_file-c0759844faf2e1001bf00216c332608d.svg";